<template>
  <div
    class="container-fluid p-4"
    :style="!completeLoad ? 'min-height: 90vh' : ''"
  >
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div class="row g-4">
      <div class="col-12 col-lg-3">
        <nav
          class="sticky-kit nav-deep nav-deep-light d-lg-block d-md-none d-sm-none d-xs-none"
        >
          <div class="card">
            <div class="card-body p-0 p-md-4">
              <button
                class="clearfix btn btn-toggle btn-sm w-100 text-align-left shadow-md border rounded d-block d-lg-none js-togglified"
                data-bs-target="#nav_questionCategories"
                data-toggle-container-class="d-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3"
                @click="btnCategoryClick"
              >
                <span class="group-icon px-2 py-2 float-start">
                  <i class="fi fi-bars-2" v-if="!isMenueActive"></i>
                  <i class="fi fi-close" v-if="isMenueActive"></i>
                </span>

                <span class="h6 py-2 m-0 float-start">
                  طبقه‌ بندی پرسش و پاسخ ها
                </span>
                <a
                  class="float-end pointer text-danger-hover"
                  href="#"
                  @click="resetSelectedSubject"
                  ><i class="fi fi-reload text-dark text-danger-hover"></i
                ></a>
              </button>
              <ul
                ref="nav_questionCategories"
                id="nav_questionCategories"
                class="nav flex-column d-lg-block mt-1 mt-lg-0 d-none"
              >
                <li v-if="!isMenueActive">
                  <div
                    class="d-flex align-items-center mb-2 pb-4 border-bottom"
                  >
                    <div class="flex-none border rounded-circle">
                      <svg
                        width="24px"
                        height="24px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-bounding-box"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"
                        ></path>
                      </svg>
                    </div>
                    <div class="w-100 px-3">
                      <span class="float-start d-block fw-bold">
                        طبقه‌ بندی پرسش و پاسخ ها
                      </span>
                      <a
                        class="float-end pointer text-danger-hover"
                        href="#"
                        @click="resetSelectedSubject"
                        ><i class="fi fi-reload text-dark text-danger-hover"></i
                      ></a>
                    </div>
                  </div>
                </li>
                <li
                  class="nav-item"
                  :class="{
                    active: searchQuestionViewModel.subjectID == subject.id,
                  }"
                  v-for="subject in allSubjects"
                  :key="subject.id"
                >
                  <a
                    class="nav-link px-0 d-flex align-items-center"
                    href="#"
                    @click="this.subjectItemClick(subject.id)"
                  >
                    <i class="fi fi-arrow-end ms-2 small"></i>
                    <span>{{ subject.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <searchable-input
          mode="single"
          placeHolder="طبقه بندی پرسش و پاسخ ها"
          ref="questionAnswerCategoryComboBox"
          :options="allSubjectLables"
          v-model:inputValue="searchQuestionViewModel.subjectID"
          @multiSelectChanged="allSubjectLablesChanged"
          inputThem="purpleThem"
          :canClear="true"
          topTitle=""
          inputTitle=""
          topTitleClass=""
          containerClass="my-1 d-block d-lg-none"
        />
      </div>

      <div class="col-12 col-lg-9">
        <div class="input-group-over d-block mb-1">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control searchBox"
              placeholder="جستجو در پرسش و پاسخ ها..."
              v-model="searchQuestionViewModel.searchInputText"
              @keydown="searchTextInputKeyDown"
            />
          </div>
          <button type="submit" class="btn smaller" @click="getQuestions">
            <i class="fi fi-search m-0"></i>
          </button>
          <button
            type="submit"
            class="btn smaller ms-5"
            v-if="searchQuestionViewModel.searchInputText"
            @click="clearSearch"
          >
            <i class="fi fi-close m-0"></i>
          </button>
        </div>
        <h5
          v-if="searchQuestionViewModel.subjectID != null"
          class="p-2 d-lg-block d-md-none d-sm-none d-xs-none"
        >
          <i class="fi fi-bars ms-2"></i>
          پرسش ها در طبقه بندی:
          <span class="fw-bold"
            >"{{ getSubjectTitle(searchQuestionViewModel.subjectID) }}"</span
          >
        </h5>
        <h5 v-if="searchQuestionViewModel.keyWord != ''" class="p-2">
          <i class="fi fi-task-list ms-2"></i>
          نتایج جستجو برای عبارت:
          <span class="fw-bold">"{{ searchQuestionViewModel.keyWord }}"</span>
        </h5>
        <div
          class="p-1 fs-5 text-secondary h-75 text-center"
          v-if="searchResult.length == 0"
        >
          <div class="y-middle">اطلاعاتی جهت وجود ندارد</div>
        </div>

        <div class="row py-3">
          <div
            v-for="item in searchResult"
            :key="item.guid"
            class="col-12 col-md-12 col-lg-4 mb-5"
          >
            <div
              class="card border-0 bg-white h-100 aos-init aos-animate shadow rounded-xl question-card"
              data-aos="fade-down"
              data-aos-delay="100"
              data-aos-offset="0"
              data-aos-once="false"
            >
              <div class="text-center pt-2 pe-2 bg-gray-300">
                <a :href="'/questionAnswerView/' + item.guid"
                  ><h3 class="fs-5 text-end fw-bold text-gray-800">
                    <!-- <svg
                      width="40px"
                      height="40px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-question-circle"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                      ></path>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                      ></path>
                    </svg> -->
                    پرسش {{ item.questionNumber }}
                  </h3>
                  <!-- <p class="px-2 smaller text-start m-0 text-gray-700">
                    <i class="fi fi-calendar"></i>
                    {{ getPersianPublishDate(item.publishDate) }}
                  </p> -->
                </a>
              </div>

              <div class="card-body">
                <a :href="'/questionAnswerView/' + item.guid"
                  ><p class="text-end text-justified text-gray-900">
                    {{ item.questionAbstract }}
                  </p></a
                >
              </div>
            </div>
          </div>
          <div class="text-center my-2">
            <button
              class="btn btn-soft btn-blueSite btn-sm"
              v-if="hasMoreRecord && completeLoad"
              @click="moreQuestionAnswerClick"
            >
              <i class="fi fi-arrow-down-full"></i>
              <span>نمایش بیشتر</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../components/form/searchableInput/SearchableInput.vue';

export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  data() {
    return {
      isMenueActive: false,
      allSubjects: [],
      allSubjectLables: [],
      searchResult: [],
      hasMoreRecord: true,
      completeLoad: false,
      searchQuestionViewModel: {
        subjectID: null,
        recordCount: 9,
        keyWord: '',
        searchInputText: '',
      },
    };
  },
  methods: {
    btnCategoryClick() {
      'd-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3'
        .split(' ')
        .forEach((f) => {
          this.$refs.nav_questionCategories.classList.toggle(f);
        });
      this.isMenueActive = !this.isMenueActive;
    },
    getSubjectTitle(id) {
      return this.allSubjects.find((f) => f.id == id)?.title ?? '';
    },
    async searchTextInputKeyDown(e) {
      if (e.key == 'Enter') {
        // this.searchQuestionViewModel.subjectID = null;
        await this.getQuestions();
      }
    },
    async clearSearch() {
      this.searchQuestionViewModel.keyWord = '';
      this.searchQuestionViewModel.searchInputText = '';
      await this.getQuestions();
    },
    async allSubjectLablesChanged(id) {
      let that = this;
      that.searchQuestionViewModel.subjectID = id;
      that.searchQuestionViewModel.searchInputText = '';
      await this.getQuestions();
    },
    async getAllSubjects() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get('/ST/Subject/GetAllSubjects')
        .then((response) => {
          that.allSubjects = response.data;
          that.allSubjectLables = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async subjectItemClick(id) {
      let that = this;
      that.searchQuestionViewModel.subjectID = id;
      that.searchQuestionViewModel.searchInputText = '';
      await this.getQuestions();
    },
    async getQuestions() {
      let that = this;
      if (that.searchQuestionViewModel.searchInputText) {
        that.searchQuestionViewModel.keyWord =
          that.searchQuestionViewModel.searchInputText;
      } else {
        that.searchQuestionViewModel.keyWord = '';
      }
      this.$refs.spinner.show();

      await axios
        .post(
          '/ST/QuestionAnswer/SearchQuestionAnswers',
          that.searchQuestionViewModel
        )
        .then((response) => {
          that.searchResult = response.data.questionAnswerData;
          that.hasMoreRecord =
            response.data.allRecourdCount >
            response.data.questionAnswerData.length;
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getPersianPublishDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('LLLLL');
    },
    async moreQuestionAnswerClick() {
      this.searchQuestionViewModel.recordCount += 9;
      await this.getQuestions();
    },
    async resetSelectedSubject() {
      this.searchQuestionViewModel.subjectID = null;
      await this.getQuestions();
    },
  },
  async mounted() {
    try {
      this.$refs.spinner.show();
      await this.getAllSubjects();
      await this.getQuestions();
      this.completeLoad = true;
    } finally {
      this.$refs.spinner.hide();
    }
  },
};
</script>
<style scopped></style>
